import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import {TabList} from '../../styles/style.js'

class Tabs extends Component {
    static propTypes = {
      children: PropTypes.instanceOf(Array).isRequired,
    }
  
    constructor(props) {
      super(props);

      this.state = {
        activeTab: '',};
    }

    componentDidMount(){
      if(this.props.selectedForm){
        this.props.selectedForm(this.props.children[0].props.label)
      }
      this.setState({activeTab:this.props.children[0].props.label})
    }
  
    onClickTabItem = (tab) => {
      this.setState({ activeTab: tab });
      if(this.props.selectedForm){
        this.props.selectedForm(tab)
      }
    }

    render() {
        const {
          onClickTabItem,
          props: {
            children,
          },
          state: {
            activeTab,
          }
        } = this;
    
        return (
          <div>
            <TabList>
              {children.map((child) => {
                return (
                  <Tab
                    activeTab={activeTab}
                    key={child.props.label}
                    label={child.props.label}
                    severity={child.props.severity !== undefined ? child.props.severity : ''}
                    onClick={onClickTabItem}
                  />
                );
              })}
            </TabList>
            <div>
              {children.map((child) => {
                if (child.props.label !== activeTab) return undefined;
                return child.props.children;
              })}
            </div>
          </div>
        );
    }
}
    
export default Tabs;  